@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  // These numbers tend to change together.
  // They control the size of the check/number circle and the position of the heading relative to it.
  --circle-width: 40px;
  --icon-width: 20px;
  --heading-offset: 6px;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content 1fr;
  align-items: flex-start;
  gap: 16px;

  padding: 24px 28px;

  background-color: var(--blue-03);
  color: var(--black);

  @include breakpoints.desktop {
    --circle-width: 62px;
    --icon-width: 32px;
    --heading-offset: 16px;

    gap: 28px;
  }
}

.containerDark {
  background-color: var(--blue-01);
  color: var(--white);
}

.heading {
  margin: var(--heading-offset) 0 0 0; // vertically center with number/check
}

.heading,
.number {
  @include typography.heading3;
}

.number,
.check {
  display: flex;
  align-items: center;
  justify-content: center;

  height: var(--circle-width);
  width: var(--circle-width);

  border-radius: 100%;
}

.number {
  border: 2px solid var(--blue-02-at-30);
  padding-left: 0.125em; // nudge for optical centering
}

.check {
  border: 2px solid var(--blue-03);
  background-color: var(--blue-02);

  > img {
    width: var(--icon-width);
  }
}

.note {
  @include typography.heading4;

  color: var(--gray-02);
  margin: 4px 0 0;
}
